
export default {
  methods: {
    getGameName(code) {
      let gameInfo = this.getGameByCode(code)
      return gameInfo ? gameInfo.name : code;
    },
    getGameIcon(code) {
      let gameInfo = this.getGameByCode(code)
      return gameInfo ? gameInfo.mdi_icon : 'mdi-help';
    },
    getGameByCode(code) {
      if (this.$store.state.games) {
        return this.$store.state.games.find((game) => {
          return game.code == code;
        })
      }
      return undefined;
    }
  }
}
